module.exports = __webpack_public_path__ + "img/slide-2-explore-an-interactive-2.5ddfc8e1.png";